





























import Vue from 'vue'
import { createLogo, updateLogo } from '../../services';
export default Vue.extend({
    props: {
        logo: Object,
        reset: {}
    },
    data: () => ({
        titleRules: [(v) => !!v || 'Titel muss angegeben werden'],
        fileUpload: undefined as any
    }),
    watch: {
        reset: function(reset: boolean) {
            if (reset) {
                if (this.logo.id) {
                    (this.$refs.form as any).resetValidation();
                } else {
                    (this.$refs.form as any).reset();
                }
            }
        }
    },
    methods: {
        closeDialog() {
            this.$emit('close');
            (this.$refs.form as any).reset();
        },
        async save() {
            if (!(this.$refs.form as any).validate()) {
                return;
            }
            let success;
            if (this.logo.id) {
                success = await updateLogo({id: this.logo.id, title: this.logo.title, image: this.fileUpload});
            } else {
                success = await createLogo({title: this.logo.title, image: this.fileUpload});
            }
            if (success) {
                this.$emit('close', success);
                (this.$refs.form as any).reset();
            }
        },
        updatePreview(file?: File) {
            if (!file) {
                this.logo.image = undefined;
                this.fileUpload = undefined;
                return;
            }
            this.fileUpload = file;
            const url = URL.createObjectURL(file)
            this.logo.image = url;
            this.$forceUpdate();
        }
    }
})
